<div class="kt-checkbox-list">
    <label class="kt-checkbox kt-checkbox--solid">
        <input type="checkbox" [(ngModel)]="checked" value="true">
        <span></span>
    </label>
</div>